import React, { useEffect, useState } from 'react';
import { Box, Icons } from '@ublend-npm/aulaui-core';
import HandinLogo from '../../../../../../static/handin-logo.svg';
import TurnitinLogo from '../../../../../../static/turnitin.png';
import QuizzesLogo from '../../../../../../static/quizzes.png';
import SSALogo from '../../../../../../static/ssa-logo.png';
import { SSA_PROVIDER } from '@core/assignments/constants';

type AssignmentProviderLogoProps = {
  imageSrc?: string;
  providerType: string;
  providerName?: string;
};

const StaticLogos = {
  'hand-in': HandinLogo,
  handin: HandinLogo,
  turnitin: TurnitinLogo,
  quizzes: QuizzesLogo,
  [SSA_PROVIDER]: SSALogo,
};

export const AssignmentProviderLogo = ({
  imageSrc,
  providerType,
  providerName = providerType,
}: AssignmentProviderLogoProps) => {
  const [imageError, setImageError] = useState(false);
  const src = StaticLogos[providerType] || imageSrc;

  useEffect(() => {
    setImageError(false);
  }, [src]);

  if (!src || imageError) {
    const { ExtensionOutlined } = Icons;
    return (
      <Box>
        <ExtensionOutlined />
      </Box>
    );
  }

  return (
    <img
      width="24px"
      height="24px"
      src={src}
      alt="assignment"
      aria-label={`${providerName} icon`}
      onError={() => setImageError(true)}
    />
  );
};
